import { render } from "./document-thumbnail.vue?vue&type=template&id=e81e744e&scoped=true"
import script from "./document-thumbnail.vue?vue&type=script&lang=js"
export * from "./document-thumbnail.vue?vue&type=script&lang=js"

import "./document-thumbnail.vue?vue&type=style&index=0&id=e81e744e&scoped=true&lang=scss"

import exportComponent from "C:\\Users\\softw\\Documents\\Software\\Projects\\CodeRedLabs\\manila-customer\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-e81e744e"]])

export default __exports__